import React from "react";
import SlideMarker from "./SlideMarker";
import {IPTSlideEvent} from "../../interfaces/IPTInformation";

interface ISlideMarkerListProps {
    slideEvents: ReadonlyArray<IPTSlideEvent>;
    currentMarkerIndex?: number;
    duration: number;
    onClick: (index: number, markerCurrentTime: number) => void;
}

const SlideMarkerList: React.FC<ISlideMarkerListProps> = ({
                                                              slideEvents,
                                                              currentMarkerIndex,
                                                              duration,
                                                              onClick
                                                          }) => {

    return (
        <>
            {slideEvents.map((slideEvent, index) => {
                const isVisible = index === currentMarkerIndex;
                const percentage = ((slideEvent.indexTime / 1000) / duration) * 100;
                return (
                    <SlideMarker
                        key={slideEvent.indexTime}
                        percentage={percentage}
                        visible={isVisible}
                        context={(slideEvent.slideIndex + 1)+""}
                        onClick={(e: any) => {
                            const markerCurrentTime = duration * (percentage / 100);
                            onClick(index, markerCurrentTime + 0.00001);
                            e.preventDefault();
                            e.stopPropagation();
                        }}
                    />
                )
            })}
        </>
    );
};

export default SlideMarkerList;
